import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService, NotificationService, TmsWebBaseEditCreateService } from 'tms-lib';
import { SellingCompanyWarehouseConnection } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class SellingCompanyWarehouseConnectionService extends TmsWebBaseEditCreateService<
  SellingCompanyWarehouseConnection,
  SellingCompanyWarehouseConnection
> {
  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super(
      'SellingCompanyWarehouseConnection',
      $localize`Selling Company Warehouse Connection`,
      httpService,
      notificationService,
    );
  }

  getForSellingCompany(id: string): Observable<SellingCompanyWarehouseConnection[]> {
    return this.httpService.get<SellingCompanyWarehouseConnection[]>(
      `${this.apiUrl}/GetForSellingCompanyWarehouse?id=${id}`,
    );
  }
}
